import React from 'react';
import { MainLayout } from '@/components/MainLayout';
import { PaymentAccountPage } from '@/components/payment-accounts/PaymentAccountPage';

export default function PaymentAccountsPage() {
  return (
    <MainLayout>
      <PaymentAccountPage />
    </MainLayout>
  );
}

